import React, { useState } from 'react';
import Functions from '../../api/Functions';
import M from 'materialize-css';
import { Link } from 'react-router-dom';

function PlaceSearch(props) {
  const [isImporting, setIsImporting] = useState(false);
  const { placeSearch } = props;

  const copyIdToClipboard = () => {
    navigator.clipboard.writeText(placeSearch.id);
    M.toast({ html: 'ID copied' });
  };

  const importPyns = () => {
    setIsImporting(true);
    Functions.importPynsByPlaceSearchIdCall(placeSearch.id)
      .then(() => {
        setIsImporting(false);
      })
      .catch((e) => {
        setIsImporting(false);
        M.toast({ html: `Error: ${e.message}` });
      });
  };

  const publishPyns = () => {
    if (!placeSearch.completed) return;
    setIsImporting(true);
    Functions.convertPynsImportedToPynsByPlaceSearchIdCall(placeSearch.id)
      .then(() => {
        setIsImporting(false);
      })
      .catch((e) => {
        setIsImporting(false);
        M.toast({ html: `Error: ${e.message}` });
      });
  };

  return (
    <div className="col s12 m6">
      <div className="card z-depth-0 project-summary">
        <div className="card-content grey-text text-darken-3">
          <div className="row">
            <div className="col s6"></div>
            <div className="col s6">
              <button type="button" onClick={() => copyIdToClipboard()} className="btn-id">
                ID: {placeSearch.id}
              </button>
            </div>
          </div>
          <span className="company-address">Company Name: {placeSearch.companyName}</span>
          {placeSearch.country ? <p className="company-address"> Country: {placeSearch.country}</p> : <p className="company-address">&nbsp;</p>}
          {placeSearch.state ? <p className="company-address"> State: {placeSearch.state}</p> : <p className="company-address">&nbsp;</p>}
          {placeSearch.city ? <p className="company-address"> City: {placeSearch.city}</p> : <p className="company-address">&nbsp;</p>}
          {placeSearch.completed !== undefined ? <p className="company-address"> Is Completed?: {placeSearch.completed.toString()}</p> : <p className="company-address">&nbsp;</p>}
          {placeSearch.count ? <p className="company-address"> Count: {placeSearch.count.toString()}</p> : <p className="company-address">&nbsp;</p>}
          {placeSearch.type ? <p className="company-address"> Type: {placeSearch.type}</p> : <p className="company-address">&nbsp;</p>}
          <div className="progress" style={{ visibility: isImporting ? 'visible' : 'hidden' }}>
            <div className="indeterminate"></div>
          </div>
        </div>
        <div className="card-action-disabled">
          <Link className="btn-flat" to={'/place/' + placeSearch.id} key={'view_' + placeSearch.id}>
            View
          </Link>
          <Link
            className="btn-flat"
            to={{
              pathname: '/newPlaceSearch',
              placeSearch: placeSearch,
              edit: true,
            }}>
            Edit
          </Link>
          <Link
            className="btn-flat"
            to={{
              pathname: '/newPlaceSearch',
              placeSearch: placeSearch,
              edit: false,
            }}>
            Clone
          </Link>
          <button className="btn-flat" disabled={placeSearch.completed} onClick={(e) => importPyns()}>
            Import
          </button>
          <button className="btn-flat" disabled={!placeSearch.completed} onClick={(e) => publishPyns()}>
            Publish
          </button>
        </div>
      </div>
    </div>
  );
}

export default PlaceSearch;
